import React, { useState, useEffect } from "react";
import "./Infrastructure.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Background from "../../Background/Background";
import Contact from "../../4.Contact/Contact";
import Card from "react-bootstrap/Card";
import Modal from "../../Modal/Modal";

// Import Images
import img1 from "../../../assets/ITServices.webp";
import img2 from "../../../assets/ITData.jpg";
import redes from "../../../assets/redes.jpeg";
import servidores from "../../../assets/servidores.jpg";
import backup from "../../../assets/backup.jpg";
import virtualizacion from "../../../assets/virtualizacion.jpg";
import seguridad from "../../../assets/seguridad.jpg";
import database from "../../../assets/database.jpg";
import cloud from "../../../assets/cloud.jpg";
import integracion from "../../../assets/integracion.png";
import monitoreo from "../../../assets/monitoreo.jpg";
import acceso from "../../../assets/acceso.png";
import email from "../../../assets/email.jpg";
import improve from "../../../assets/improve.png";

const Infrastructure = () => {
  const [showModal, setShowModal] = useState(false);

  const [alignItems, setAlignItems] = useState("start");

  const [is768px, setIs768px] = useState(window.innerWidth <= 768);

  const [is440px, setIs440px] = useState(window.innerWidth <= 440);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setAlignItems("center");
        setIs768px(true);
      } else if (window.innerWidth <= 440) {
        setIs440px(true);
        setAlignItems("center");
      }
      else {
        setAlignItems("start");
        setIs768px(false);
        setIs440px(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleContactClick = () => {
    setShowModal(true);
  };
  return (
    <>
      <Background />
      <div className="container-i container">
        <h2 className="text-center txt-h2-i fw-bold">
          INFRAESTRUCTURA
        </h2>
        <Container
          fluid
          className="text-center d-flex flex-column align-items-center justify-content-center"
        >
          <Row className="align-items-center justify-content-center grid-h grid-align-1">
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
            >
              <h3 className={`fw-bold text-uppercase ${is768px ? "" : "ms-5"}`}>
                ¿Que es la Infraestructura IT?
              </h3>
              <div
                className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
              >
                <p
                  className={`text-${is768px ? "center" : "start"} ${
                    is768px ? "" : "ms-5"
                  }`}
                >
                  La infraestructura de tecnología de la información (IT) es
                  como la columna vertebral de cualquier empresa cuando se trata
                  de sus operaciones digitales. Es el conjunto de hardware,
                  software, redes y servicios necesarios para que una
                  organización pueda funcionar de manera efectiva en el mundo
                  digital. Es como la estructura de una casa: si está bien
                  diseñada y mantenida, todo funciona sin problemas, pero si hay
                  problemas, todo puede venirse abajo.
                </p>
              </div>
              <Button
                size="sm"
                className="btn-i mt-3 fs-5 fw-bold"
                onClick={handleContactClick}
              >
                ¡QUIERO SABER MÁS!
              </Button>
            </Col>
            <Col>
              <img
                src={img1}
                className="img-logo shadow img-grid-1"
                alt="Imagen ilustrativa"
              />
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center grid-h grid-align-2">
            <Col>
              <img
                src={img2}
                className="img-logo shadow img-grid-2"
                alt="Imagen ilustrativa"
              />
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
            >
              <h3
                className={`fw-bold mt-i text-uppercase ${
                  is768px ? "" : "ms-5"
                }`}
              >
                ¿Por qué es importante?
              </h3>
              <div
                className={`d-flex flex-column align-items-${alignItems} justify-content-center`}
              >
                <p className={`text-start mt-3 ${is768px ? "" : "ms-5"}`}>
                  Porque es como la base tecnológica sobre la cual una empresa
                  construye y opera sus sistemas de información y comunicación.
                  Esto incluye desde servidores y computadoras hasta redes de
                  comunicación, almacenamiento de datos, software de gestión y
                  seguridad informática. Sin una infraestructura IT sólida y
                  eficiente, las empresas pueden experimentar dificultades para
                  funcionar de manera efectiva en el entorno digital actual.
                </p>
              </div>
              <Button
                size="sm"
                className="btn-i mt-3 fs-5 fw-bold img-responsive margin-bi2"
                onClick={handleContactClick}
              >
                ¡QUIERO SABER MÁS!
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bkg2sec pb-5">
        <h3 className="mt-5 pt-5 text-center fw-bold sub-title-i text-uppercase">
          Nuestros Servicios
        </h3>
        <Container
          fluid
          className="text-center d-flex flex-column align-items-center justify-content-center container grid-i"
        >
          <Row className="align-items-center justify-content-center grid-h container">
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={redes} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Redes <br />
                    Empresariales
                  </Card.Title>
                  <Card.Text>
                    Diseño y despliegue de redes seguras y escalables para
                    adaptarse a tus necesidades, garantizando conectividad
                    confiable y óptimo rendimiento.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={servidores} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Servidores <br />
                    Personalizados
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Servidores físicos y virtuales configurados según tus
                    requisitos, asegurando un funcionamiento eficaz para de tus
                    aplicaciones y servicios.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={backup} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Almacenamiento y <br />
                    Backup
                  </Card.Title>
                  <Card.Text>
                    Implementamos sistemas de almacenamiento <br />
                    seguro para proteger tus datos, con soluciones de backup
                    automatizadas y confiables.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={virtualizacion} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Virtualización de <br />
                    Infraestructura
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Optimización de tu infraestructura mediante la
                    virtualización, ahorrando costos y simplificando la
                    administración <br />
                    de recursos.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center grid-h container">
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={seguridad} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Seguridad de la <br />
                    Información
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Protegemos tus activos digitales con soluciones avanzadas de
                    seguridad, que incluyen firewall, detección de intrusiones y
                    antivirus.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={database} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Gestión de <br />
                    Bases de Datos
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Administración de bases de datos para garantizar rendimiento
                    óptimo, <br />
                    alta disponibilidad y seguridad de la información.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={cloud} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Infraestructura <br />
                    en la Nube
                  </Card.Title>
                  <Card.Text>
                    Diseño, implementación y gestión de entornos en la nube para
                    mejorar la eficiencia <br />
                    operativa y la escalabilidad de tu empresa.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={integracion} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Integración <br />
                    de Sistemas
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Integración de <br />
                    sistemas y aplicaciones para mejorar la productividad y la{" "}
                    <br />
                    colaboración dentro de tu organización.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center grid-h grid3-i container">
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={monitoreo} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Monitorización <br />
                    Proactiva
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Supervisión continua de tu infraestructura para identificar,
                    analizar y resolver problemas antes de que afecten
                    negativamente tu negocio.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={acceso} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Gestión de Identidad y Acceso
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Implementación de soluciones completas para proteger tus
                    recursos, garantizando acceso autorizado y seguridad
                    avanzada en tu empresa.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={email} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Correo Electrónico y Colaboración
                  </Card.Title>
                  <Card.Text>
                    Configuración y gestión <br />
                    de correo electrónico y colaboración para mejorar la
                    comunicación y la productividad en tu empresa.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            <Col
              className={`d-flex flex-column align-items-${alignItems} justify-content-center ${
                is440px ? "col-12" : "col-6"
              } col-lg-3`}
            >
              <Card className={`${is440px ? "w-75" : "w-100"}`}>
                <Card.Img variant="top" src={improve} />
                <Card.Body>
                  <Card.Title className="fw-bold">
                    Modernización de Infraestructura
                  </Card.Title>
                  <Card.Text className="parrmb">
                    Evaluación y recomendaciones para modernizar y optimizar tu
                    infraestructura, mejorando eficiencia y competitividad
                    empresarial.
                  </Card.Text>
                  <Button
                    className="btn-i-card fw-bold"
                    onClick={handleContactClick}
                  >
                    CONSULTAR
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Contact />
      <Modal show={showModal} setShow={setShowModal} />
    </>
  );
};

export default Infrastructure;
